/* eslint max-len: ["error", 160] */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';

class TableLoading extends Component {
    componentDidMount() {
        this.place();
    }

    componentWillUpdate() {
        this.place();
    }

    place() {
        if (!$) {
            this.overlayDOM.style.top = 0;
            this.iconDOM.style.top = '10px';

            return;
        }

        const offset = 20;
        const margin = $(this.node).find('thead').height() || 0;
        const viewTop = $(window).scrollTop();
        const viewBottom = viewTop + $(window).height();
        const tableTop = $(this.node).offset().top + margin;
        const tableBottom = tableTop + $(this.node).height();

        let top = 0;

        if (viewTop <= tableTop && viewBottom <= tableBottom) {
            top = (viewBottom - tableTop) / 2;
        } else if (viewTop >= tableTop && viewBottom >= tableBottom) {
            top = (viewTop - tableTop) + (tableBottom - viewTop) / 2;
        } else if (viewTop >= tableTop && viewBottom <= tableBottom) {
            top = (viewBottom - viewTop) / 2;
        } else {
            top = (tableBottom - tableTop) / 2;
        }

        top = Math.max(top - offset, 0);
        $(this.overlayDOM).css({ top: `${margin}px` });
        $(this.iconDOM).css({ top: `${top}px` });
    }

    render() {
        return (
            <div className="bsp__tableWrapper" ref={(node) => { this.node = node; }}>
                <div
                    className={classNames('bsp__tableLoading', { hidden: !this.props.loading })}
                    ref={(node) => { this.overlayDOM = node; }}
                >
                    <svg
                        className="ui-icon ui-icon_size2XL"
                        ref={(node) => { this.iconDOM = node; }}
                    >
                        <use xlinkHref="img/icons.svg#icon-spinner" />
                    </svg>
                </div>
                {this.props.children}
            </div>
        );
    }
}

TableLoading.propTypes = {
    loading: PropTypes.bool,
    children: PropTypes.object
};

export default TableLoading;



// WEBPACK FOOTER //
// ./src/js/modules/DataTable/components/TableLoading.js